import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import './CustomDateRange.css';

import { Button, Menu } from '@mui/material';
import moment from 'moment';
import React, { FC, useState } from 'react';
import { DateRange, RangeKeyDict } from 'react-date-range';

import { Icons } from '../../../assets/SvgIcons';

moment.locale();

type CustomDateRangeProps = {
  startDate?: Date;
  endDate?: Date;
  disabled: boolean;
  onDateChange: (startDate: Date | null, endDate: Date | null) => void;
};

type DateInputProps = {
  startDate: Date | null;
  endDate: Date | null;
  key: string;
};

const CustomDateRange: FC<CustomDateRangeProps> = ({
  startDate,
  endDate,
  disabled,
  onDateChange,
}) => {
  const [selectedStartDate, setSelectedStartDate] = useState<Date | undefined>(
    startDate
  );
  const [selectedEndDate, setSelectedEndDate] = useState<Date | undefined>(
    endDate
  );

  const [state, setState] = useState<DateInputProps[]>([
    {
      startDate: startDate ?? null,
      endDate: endDate ?? null,
      key: 'selection',
    },
  ]);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [dateSelected, setDateSelected] = useState<string>('endDate');

  // useEffect(() => {
  //   setTimeout(() => {
  //     setSelectedStartDate(startDate);
  //     setSelectedEndDate(endDate);
  //     if (!startDate && !endDate) {
  //       setState([
  //         {
  //           startDate: null,
  //           endDate: null,
  //           key: 'selection',
  //         },
  //       ]);
  //     } else if (!startDate && endDate) {
  //       setState([
  //         {
  //           startDate: endDate,
  //           endDate: endDate,
  //           key: 'selection',
  //         },
  //       ]);
  //     } else if (startDate && !endDate) {
  //       setState([
  //         {
  //           startDate: startDate,
  //           endDate: startDate,
  //           key: 'selection',
  //         },
  //       ]);
  //     } else {
  //       setState([
  //         {
  //           startDate: startDate ?? null,
  //           endDate: endDate ?? null,
  //           key: 'selection',
  //         },
  //       ]);
  //       setDateSelected('');
  //     }
  //   }, 500);
  // }, [startDate, endDate]);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const onDateRangeChange = (item: RangeKeyDict) => {
    if (item.selection.startDate === item.selection.endDate) {
      if (dateSelected === 'endDate') {
        setSelectedEndDate(item.selection.endDate);
        setSelectedStartDate(undefined);
        onDateChange(null, item.selection.endDate as Date);
      } else if (dateSelected === 'startDate') {
        setSelectedEndDate(undefined);
        setSelectedStartDate(item.selection.startDate);
        onDateChange(item.selection.startDate as Date, null);
      } else {
        setSelectedEndDate(item.selection.endDate);
        setSelectedStartDate(item.selection.startDate);
        onDateChange(
          item.selection.startDate as Date,
          item.selection.endDate as Date
        );
      }
    } else {
      setSelectedEndDate(item.selection.endDate);
      setSelectedStartDate(item.selection.startDate);
      onDateChange(
        item.selection.startDate as Date,
        item.selection.endDate as Date
      );
    }

    setState([item.selection as DateInputProps]);
  };

  const onDateRangeClear = () => {
    setState([
      {
        startDate: null,
        endDate: null,
        key: 'selection',
      },
    ]);
    setSelectedEndDate(undefined);
    setSelectedStartDate(undefined);
    onDateChange(null, null);
  };

  const setValue = () => {
    if (selectedEndDate && selectedStartDate) {
      return (
        <>
          {moment(selectedStartDate).format('MM/DD/YYYY')}
          <Icons.ArrowDown />
          {moment(selectedEndDate).format('MM/DD/YYYY')}
        </>
      );
    }
    if (selectedStartDate) {
      return `${moment(selectedStartDate).format('MM/DD/YYYY')}`;
    }
    if (selectedEndDate) {
      return `${moment(selectedEndDate).format('MM/DD/YYYY')}`;
    }

    return 'Choose due date';
  };

  return (
    <div>
      <button
        className={`button-calendar ${open && 'active'}`}
        onClick={handleClick}
        disabled={disabled}
      >
        <span className="button-calendar-title">{setValue()}</span>
        <Icons.Calendar2 />
      </button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        className="custom-date-range-wrapper"
      >
        <div className="custom-date-range-input-wp">
          <input
            className={`custom-date-range-input ${
              dateSelected === 'startDate' && 'input-active'
            }`}
            readOnly
            placeholder="+ Start date"
            value={
              selectedStartDate
                ? moment(selectedStartDate).format('MM.DD.YYYY')
                : ''
            }
          />
          <input
            className={`custom-date-range-input ${
              dateSelected === 'endDate' && 'input-active'
            }`}
            readOnly
            placeholder="+ End date"
            value={
              selectedEndDate
                ? moment(selectedEndDate).format('MM.DD.YYYY')
                : ''
            }
            onClick={() => setDateSelected('endDate')}
          />
        </div>
        <DateRange
          //onChange={item => console.log(item)}
          onChange={item => onDateRangeChange(item)}
          ranges={state as any}
          showDateDisplay={false}
          rangeColors={['#4C43AA']}
          className={
            selectedEndDate === undefined && selectedStartDate === undefined
              ? 'EmptyDateRange'
              : selectedStartDate === undefined && selectedEndDate !== undefined
              ? 'EmptyEndDateRange'
              : ''
          }
        />

        <div className="clear-wrapper" color="danger">
          <Button variant="text" onClick={onDateRangeClear}>
            Clear date
          </Button>
        </div>
      </Menu>
    </div>
  );
};

export default CustomDateRange;
